import * as React from 'react';
import { styled } from '@mui/material/styles';


const MatchPercentileRoot = styled('span')`
  padding-left: 6px;
`;

export const MatchType = ({ data }) => {
  return <MatchPercentileRoot>{data.matched_score_percentage}%</MatchPercentileRoot>
};
